module.exports = {
    apiKey: "AIzaSyDCSysvFS4RtGWqFpZoMJRqmZN9IYgQf4w",
    authDomain: "afya-production.firebaseapp.com",
    databaseURL: "https://afya-production.firebaseio.com",
    projectId: "afya-production",
    storageBucket: "afya-production.appspot.com",
    messagingSenderId: "761816859088",
    appId: "1:761816859088:web:54577cbebb12b19d8c79d5",
    measurementId: "G-5YEFB4D2K5"
  };